import axios from 'axios';
import { message } from 'ant-design-vue';
// const router = require('@/router');
import VueRouter from 'vue-router';
// import { getToken } from '@/api/code.js';
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
});
const service = axios.create({
  timeout: 15000,
  headers: {
    'Access-Control-Expose-Headers': 'authorization',
    'Content-Type': 'application/json',
    // Authorization: getToken(),

  },
});

// const isRedirect = [ 'login', 'productList' ].map(item => location.href.includes(item));
const isRedirect = [ 'login', 'productList' ].map(item => location.href.indexOf(item));

// 添加请求拦截器
if (!sessionStorage.getItem('username') && !isRedirect) {
  message.error('用户未登录，请先登录！');
  router.replace({ name: 'login' });
} else {
  service.interceptors.request.use(
    config => {
      console.log(config, 88)
      // console.log(router);
      const TOKEN = localStorage.getItem('token');
      // console.log(TOKEN, 'TOKEN');
      if (TOKEN) {
        config.headers.Authorization = TOKEN; // 让每个请求携带自定义token 请根据实际情况自行修改
      }
      if(config.ContentType){
        config.headers['Content-Type'] = config.ContentType
      }
      return config;
    }, error => {
      console.log(error, 999)
      return Promise.reject(error);
    }
  );
}

service.interceptors.response.use(
  response => {
    console.log(response.status, 999)
    const code = response.status
    if (code < 200 || code > 300) {
      message.error(response.message);
      return Promise.reject('error')
    } else {
      return response
    }
  },
  error => {
    let code = 0
    try {
      code = error.response.data.code || error.response.data.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        message.error('网络请求超时');
        return Promise.reject(error)
      }
    }
    if (code) {
      if (code === 401) {
        router.push({ path: 'login' })
        window.location.reload();
      } else if (code === 403) {
        sessionStorage.clear();
        localStorage.clear();
        router.push({ path: 'login' })
        window.location.reload();
      } else {
        const errorMsg = error.response.data.message
        if (errorMsg !== undefined) {
          message.error(errorMsg);
        }
      }
    } else {
      message.error('接口请求失败');
    }
    return Promise.reject(error)
  }
)


export default service;
